<template>
  <div>
    <transition name="modal">
      <div
        v-if="isShow"
        class="modal"
        @mouseleave="hideModal"
      >
        <ul>
          <li v-for="item in options">
            <span @click="goto(item.value)">
              <img
                :src="item.imgUrl"
                alt=""
              >
            </span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  data() {
    return {
      isShow: false,
      flipMe: false,
      options: [{
        value: '1',
        label: '全国直采',
        imgUrl: require('@/assets/index/全国直采.png')
      }, {
        value: '2',
        label: '区域直采',
        imgUrl: require('@/assets/index/区域直采.png')
      }, {
        value: '3',
        label: '自有品牌',
        imgUrl: require('@/assets/index/永辉优选.jpg')
      }, {
        value: '4',
        label: '生鲜进口商品',
        imgUrl: require('@/assets/index/生鲜进口商品.png')
      }, {
        value: '5',
        label: '一村一品',
        imgUrl: require('@/assets/index/一村一品.png')
      }, {
        value: '6',
        label: '1233商品',
        imgUrl: require('@/assets/index/1233商品.png')
      }]
    }
  },
  methods: {
    showModal() {
      this.isShow = true
    },
    hideModal() {
      this.isShow = false
    },
    goto(value) {
      this.util.setVariantSession('tagId', value)
      this.util.setVariantSession('tag', this.options.filter((item) => item.value === value)[0].label)
      if (value === '5') { // 一村一品
        this.$router.push('/ovop')
      } else if (value === '3') { // 自有品牌
        this.$router.push('/ownBrandProduct')
      } else {
        this.$router.push(`/product?id=${value}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
    .modal {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 200px;
        height: 200px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        ul{
            width: 100%;
            li {
                list-style: none;
                overflow: hidden;
                position: absolute;
                top: -50%;
                left: 50%;
                width: 72%;
                height: 100%;
                z-index: 100;
               transform-origin: 0 100%;
                span{
                    display: inline-block;
                    img {
                        width: 110px;
                        height: 110px;
                        margin-top: 28px;
                        cursor: pointer;
                    }
                    img:hover {
                        width: 130px;
                        height: 130px;
                        margin-top: 14px;
                    }
                }
                .title {
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    line-height: 22px;
                    cursor: pointer;
                    color: #1b994f;
                }
            }
            li:first-child {
                transform: rotate(0deg);
            }
            li:nth-child(2) {
                transform: rotate(60deg);
                span{
                    transform: rotate(-60deg);
                }
            }
            li:nth-child(3) {
                transform: rotate(120deg);
                span{
                    transform: rotate(-120deg);
                }
            }
            li:nth-child(4) {
                transform: rotate(180deg) ;
                span{
                    transform: rotate(-180deg);
                }
            }
            li:nth-child(5) {
                transform: rotate(240deg) ;
                span{
                    transform: rotate(-240deg);
                }
            }
            li:nth-child(6) {
                transform: rotate(300deg) ;
                span{
                    transform: rotate(-300deg);
                }
            }
        }
    }
    .modal-enter-active {
        transition: transform 500ms cubic-bezier(1, 0, 0.2, 1.5);
    }
    .modal-leave-active{
        transition: transform 500ms cubic-bezier(1, -0.5, 0.2, 1);
    }
    .mask-enter-active,
    .mask-leave-active {
        transition: opacity 1300ms linear;
    }
    .mask-enter,
    .mask-leave-to {
        opacity: 0;
    }
    .modal-enter,
    .modal-leave-to {
        transform: scale(0);
    }
</style>
